import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import CuadroInformativo from './CuadroInformativo';
import DiaModalComponent from './DiaModalComponent';
import Fecha from './Fecha';
import StatusDia from './StatusDia';
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import SolicitudComponent from '../Solicitudes/SolicitudComponent';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks';
import Collapsible from 'react-collapsible';
import estilos from './Calendario.module.css'



function Dia(props) {

    const dispatch = useDispatch();
    const semana = props.semana;
    const diaDeLaSemana = semana?.descripcioneslocalidadconfiguracion[props.indexDiaDeLaSemana]?.iddia
    const zona = props.zona;

    let solicitudesAux = [];
    const [auxiliar, setAuxiliar] = React.useState([]);
    const [cajaBusqueda, setCajaBusqueda] = React.useState('');

    const [asociadosZona, setAsociadosZona] = React.useState([]);

    const [checkPendientes, setCheckPendientes] = React.useState(true);
    const [checkInformeEmitido, setCheckInformeEmitido] = React.useState(false);
    const [checkInformeEnRevision, setCheckInformeEnRevision] = React.useState(false);
    const [checkDictamenEmitido, setCheckDictamenEmitido] = React.useState(false);
    const [checkCompletadas, setCheckCompletadas] = React.useState(false);
    const [checkRechazadas, setCheckRechazadas] = React.useState(false);

    const handleCheckPendientes = () => {
        if (checkPendientes) { setCheckPendientes(false); }
        else { setCheckPendientes(true); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInfoEmitido = () => {
        if (checkInformeEmitido) { setCheckInformeEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(true); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInformeEnRevision = () => {
        if (checkInformeEnRevision) { setCheckInformeEnRevision(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(true); setCheckRechazadas(false); }
    };
    const handleCheckDictamenEmitido = () => {
        if (checkDictamenEmitido) { setCheckDictamenEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(true); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckCompletadas = () => {
        if (checkCompletadas) { setCheckCompletadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(true); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckRechazadas = () => {
        if (checkRechazadas) { setCheckRechazadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(true); }
    };

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1200, height: 500,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4, overflow: "scroll"
    };

    const idTipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const [visitasDia, setVisitasDia] = React.useState([])
    const [visitasFiltradas, setVisitasFiltradaas] = React.useState([]);
    const [openModalSolicitudes, setopenModalSolicitudes] = React.useState(false);
    let aux = true;
    const fechaSeleccionada = {
        diaDelMes: props.numeroDeDia,
        mes: props.mes,
        ano: props.ano
    }

    const handleModalParaTipoUsuario = () => {
        if (idTipoUsuario === 4) {
            props.handleModal(visitasDia)
        } else if (idTipoUsuario === 5) {
            props.handleModal(fechaSeleccionada)
        }
    }

    React.useEffect(() => {
        setVisitasDia([])
        props.visitasDia.map((visita) => {
            if (visita.fc_01_solicitudderegistro.solicitudesuifc01.length > 0) {
                let fecha = new Date(visita.fc_01_solicitudderegistro.solicitudesuifc01[0].fecharealdeinspeccion)
                if (props.numeroDeDia === fecha.getDate() + 1) {
                    setVisitasDia(prev => [...prev, visita.fc_01_solicitudderegistro])
                }
            } else {
                let fecha = new Date(visita.fc_01_solicitudderegistro.fechasolicitud)
                if (props.numeroDeDia === fecha.getDate() + 1) {
                    setVisitasDia(prev => [...prev, visita.fc_01_solicitudderegistro])
                }
            }
        })
    }, [props.visitasDia])

    React.useEffect(() => {
        let asociadoslocalidad = [];
        let solicitudesPorAsociado = [];

        semana?.zona.asociadosenlalocalidad.forEach((a) => {
            asociadoslocalidad.push(a.anexocliente.cliente.numerosocio);
        });

        const arraySinRepetidos = asociadoslocalidad.filter((valor, indice, arreglo) => arreglo.indexOf(valor) === indice);
        setAsociadosZona(arraySinRepetidos)
        visitasDia.forEach((visita) => {
            arraySinRepetidos.forEach((asociado) => {
                if (visita.numerosocio === asociado) {
                    if (!solicitudesPorAsociado.includes(visita)) {
                        solicitudesPorAsociado.push(visita);
                    }
                }
            });
        });
        setVisitasFiltradaas(solicitudesPorAsociado);
    }, [visitasDia])

    React.useEffect(() => {
        let asociadoslocalidad = [];
        let solicitudesPorAsociado = [];

        semana?.zona.asociadosenlalocalidad.forEach((a) => {
            asociadoslocalidad.push(a.anexocliente.cliente.numerosocio);
        });

        const arraySinRepetidos = asociadoslocalidad.filter((valor, indice, arreglo) => arreglo.indexOf(valor) === indice);
        setAsociadosZona(arraySinRepetidos)
        visitasDia.forEach((visita) => {
            arraySinRepetidos.forEach((asociado) => {
                if (visita.numerosocio === asociado) {
                    if (!solicitudesPorAsociado.includes(visita)) {
                        solicitudesPorAsociado.push(visita);
                    }
                }
            });
        });
        setVisitasFiltradaas(solicitudesPorAsociado);
    }, [])

    React.useEffect(() => {
        visitasFiltradas
    }, [visitasFiltradas])

    const handleOpenModalSolicitudes = () => {
        setopenModalSolicitudes(true)
    }

    const handleCloseModalSolicitudes = () => {
        setopenModalSolicitudes(false);
    }

    const actualizarSolicitudes = () => {
        dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
    }


    //USE EFFECT PARA SOLICITUDES
    React.useEffect(() => {

        solicitudesAux = visitasFiltradas?.filter((solicitud) => {
            if (
                solicitud.nombrerazonsocial?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.solicitudesuifc01[0]?.inspector?.nombre.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.solicitudesuifc01[0]?.inspector?.apellidos.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.folio?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase())) {
                return solicitud;
            }
        });

        checkPendientes ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 1 || solicitud.solicitudesuifc01[0]?.statusdelasolicitud == undefined) : null;
        checkInformeEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 2) : null;
        checkInformeEnRevision ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 3) : null;
        checkDictamenEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 4) : null;
        checkCompletadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 5) : null;
        checkRechazadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 6) : null;
        setAuxiliar(solicitudesAux)

    }, [cajaBusqueda, checkPendientes, checkInformeEmitido, checkDictamenEmitido, checkCompletadas, visitasFiltradas])


    const handleBuscarInstalaciones = (event) => {
        setCajaBusqueda(event.target.value);
    }

    const modalSolicitudes = () => {
        return (
            <Modal
                open={openModalSolicitudes}
                onClose={handleCloseModalSolicitudes}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Solicitudes del día
                        <hr />
                    </Typography>


                    {/* CAJA DE BUSQUEDA  */}
                    <div className='row mb-3'>
                        {/* 1.- Solicitud asignada al inspector
                        1.- si no ha pasado el inspector: pendiente inspeccion.
                        2.- si ya paso el inspector: informe emitido.
                        3.- si esta en proceso de revision del informe: informe en revisión.
                        4.- Si ya lo reviso el gerente: dictamen emitido.
                        5.- Cuando se finalize todo el proceso: Solictud atendida */}
                        <input className='form-control' type='text' placeholder='Ingrese el nombre de la razón social, numero de solicitud o inspector' onChange={handleBuscarInstalaciones} value={cajaBusqueda}></input> <br /><hr />

                        <div className='col-2'>
                            <div className="form-check" style={{ display: 'inline-block !important' }}>
                                <input className="form-check-input" type="checkbox" checked={checkPendientes} onChange={handleCheckPendientes}>
                                </input>
                                <label className="form-check-label">
                                    Pendientes
                                </label>
                            </div>
                        </div>
                        <div className='col-2'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={checkInformeEmitido} onChange={handleCheckInfoEmitido}>
                                </input>
                                <label className="form-check-label">
                                    Informe emitido
                                </label>
                            </div>
                        </div>
                        <div className='col-2'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={checkInformeEnRevision} onChange={handleCheckInformeEnRevision}>
                                </input>
                                <label className="form-check-label">
                                    Informe en revisión
                                </label>
                            </div>
                        </div>
                        <div className='col-2'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={checkDictamenEmitido} onChange={handleCheckDictamenEmitido}>
                                </input>
                                <label className="form-check-label">
                                    Dictámen emitido
                                </label>
                            </div>
                        </div>
                        <div className='col-2'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={checkCompletadas} onChange={handleCheckCompletadas}>
                                </input>
                                <label className="form-check-label">
                                    Completadas
                                </label>
                            </div>
                        </div>
                        <div className='col-2'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={checkRechazadas} onChange={handleCheckRechazadas}>
                                </input>
                                <label className="form-check-label">
                                    Rechazadas
                                </label>
                            </div>
                        </div>
                    </div>

                    <div>
                        {
                            auxiliar.map((solicitud, index) => {
                                return (
                                    <SolicitudComponent key={index} solicitud={solicitud} user={2} status={1} tipo={1} isCalendario={true} handleCloseModalSolicitudes={handleCloseModalSolicitudes} actualizarSolicitudes={actualizarSolicitudes}></SolicitudComponent>
                                )
                            })
                        }
                    </div>


                </Box>
            </Modal>
        )
    }


    return (
        <Fragment>
            <div className="row" style={{ border: '2px solid black', padding: '0% !important', height: '100%' }}>

                <Fecha numeroDeDia={props.numeroDeDia}></Fecha>
                <StatusDia status={4} datos={visitasFiltradas}></StatusDia>
                <CuadroInformativo indexDiaDeLaSemana={props.indexDiaDeLaSemana - 1} empresa="MacDonals Centro" datos={visitasFiltradas}></CuadroInformativo>
                <button className='badge bg-success' onClick={() => { handleOpenModalSolicitudes() }}> Ver Solicitudes</button>


                <Collapsible trigger={'Detalles'}>

                    <div className='mt-4'><strong style={{ color: 'green' }} >

                        {
                            semana?.sublocalidadporsemanaaldia?.map((obj, p) => {
                                return (
                                    <Fragment>{
                                        props.indexDiaDeLaSemana - 1 == 1 ? (
                                            <h4 style={{ fontSize: '16px', fontWeight: 'bolder', wordWrap: 'break-word' }}></h4>
                                        ) :

                                            obj.iddia == props.indexDiaDeLaSemana - 1 ?
                                                (<h4 style={{ fontSize: '16px', fontWeight: 'bolder', wordWrap: 'break-word' }}>{obj.sublocalidad.nombresublocalidad}</h4>)
                                                : (null)
                                    }
                                    </Fragment>
                                )
                            })
                        }
                        <hr />
                        {/** HAY 6 días en cada semana */}
                        <p style={{ fontSize: '13px', wordWrap: 'break-word' }}>
                            { /*DOMINGO  */
                                props.indexDiaDeLaSemana - 1 == 1 ? (
                                    <p></p>
                                ) : (<p></p>)
                            }
                            { /*LUNES  */
                                (props.indexDiaDeLaSemana - 1) == 2 ? (
                                    <p>

                                        {semana?.descripcioneslocalidadconfiguracion[0]?.descripcion}
                                        <br />
                                        <hr />
                                        {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                    </p>
                                ) : (<p></p>)
                            }
                            {(props.indexDiaDeLaSemana - 1) == 3 ? (

                                <p>
                                    {semana?.descripcioneslocalidadconfiguracion[1]?.descripcion}
                                    <br />
                                    <hr />
                                    {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                </p>
                            ) : (<p></p>)
                            }
                            {(props.indexDiaDeLaSemana - 1) == 4 ? (
                                <p>

                                    {semana?.descripcioneslocalidadconfiguracion[2]?.descripcion}
                                    <br />
                                    <hr />
                                    {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                </p>
                            ) : (<p></p>)
                            }
                            {(props.indexDiaDeLaSemana - 1) == 5 ? (
                                <p>

                                    {semana?.descripcioneslocalidadconfiguracion[3]?.descripcion}
                                    <br />
                                    <hr />
                                    {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                </p>
                            ) : (<p></p>)
                            }
                            {(props.indexDiaDeLaSemana - 1) == 6 ? (
                                <p>

                                    {semana?.descripcioneslocalidadconfiguracion[4]?.descripcion}
                                    <br />
                                    <hr />
                                    {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                </p>
                            ) : (<p></p>)
                            }
                            {(props.indexDiaDeLaSemana - 1) == 7 ? (
                                <p>
                                    {semana?.descripcioneslocalidadconfiguracion[5]?.descripcion}
                                    <br />
                                    <hr />
                                    {/* {
                                        asociadosZona.map((a) => {
                                            return (
                                                <p>
                                                    {a}
                                                </p>
                                            )
                                        })
                                    } */}
                                </p>
                            ) : (<p></p>)
                            }
                        </p>

                    </strong>
                    </div>
                </Collapsible>
            </div>
            {modalSolicitudes()}
        </Fragment >
    );
};


export default withRouter(Dia)